// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"762":"c43a2380","859":"4913607d"}[chunkId] + ".chunk.js";
};